import React from 'react';
import { Paper } from '@mui/material';
import TextInput from 'screens/components/basic/TextInput';
import CheckInput from 'screens/components/basic/CheckInput';
import Button from 'screens/components/basic/Button';

const LoginPage = () => {
    return (
        <div className="container container-table">
            <div className="row vertical-center-row">
                <div className="text-center col-md-4 col-md-offset-4" >
                    <Paper className="login-paper-frame" zDepth={2} >
                        <div className="row">
                            <div className="col-md-12"><TextInput name="userName" hintText="Username" /></div>
                            <div className="col-md-12"><TextInput name="password" hintText="Password" type="password" /></div>
                            <div className="col-md-12"><CheckInput name="rememberMe" text="Remember me" /></div>
                            <div className="col-md-12"><Button text="Login" style={{ width: "90%" }} primary /></div>
                        </div>
                    </Paper>
                </div>
            </div>
        </div>
    );
};
export default LoginPage;